import(/* webpackMode: "eager", webpackExports: ["PricingTable"] */ "/vercel/path0/components/landing/PricingTable.tsx");
